// This file is auto-generated by Velocious. Do not edit it manually — any changes
// will be overwritten the next time it is generated. Run `velocious generate:frontend-models` to regenerate.
import FrontendModelBase from "velocious/build/src/frontend-models/base.js"

/**
 * Frontend model resource config.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelResourceConfig} FrontendModelResourceConfig
 */
/**
 * Fallback attribute value type for generated fields without narrower metadata.
 * @typedef {import("velocious/build/src/frontend-models/base.js").FrontendModelAttributeValue} FrontendModelAttributeValue
 */

/**
 * CommentAttributes type.
 * @typedef {object} CommentAttributes
 * @property {string} id - Attribute value.
 * @property {string | null} automationKind - Attribute value.
 * @property {string | null} comment - Attribute value.
 * @property {Date | null} createdAt - Attribute value.
 * @property {string | null} resourceId - Attribute value.
 * @property {string | null} resourceType - Attribute value.
 * @property {Date | null} updatedAt - Attribute value.
 * @property {string | null} userId - Attribute value.
 */
/**
 * Attributes accepted by CommentCreateAttributes.
 * @typedef {object} CommentCreateAttributes
 * @property {CommentAttributes["comment"] | null} [comment] - Permitted comment value.
 * @property {CommentAttributes["resourceId"] | null} [resourceId] - Permitted resourceId value.
 * @property {CommentAttributes["resourceType"] | null} [resourceType] - Permitted resourceType value.
 * @property {CommentAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Attributes accepted by CommentUpdateAttributes.
 * @typedef {object} CommentUpdateAttributes
 * @property {CommentAttributes["comment"] | null} [comment] - Permitted comment value.
 * @property {CommentAttributes["resourceId"] | null} [resourceId] - Permitted resourceId value.
 * @property {CommentAttributes["resourceType"] | null} [resourceType] - Permitted resourceType value.
 * @property {CommentAttributes["userId"] | null} [userId] - Permitted userId value.
 */
/**
 * Frontend model for Comment.
 * @augments {FrontendModelBase<CommentAttributes, CommentCreateAttributes, CommentUpdateAttributes, CommentAttributes["id"], string>}
 */
class Comment extends FrontendModelBase {
  /** @returns {FrontendModelResourceConfig} - Resource config. */
  static resourceConfig() {
    return {
      modelName: "Comment",
      attributes: [
        "id",
        "automationKind",
        "comment",
        "createdAt",
        "resourceId",
        "resourceType",
        "updatedAt",
        "userId",
      ],
    }
  }

  /** @returns {Record<string, {type: "belongsTo" | "hasOne" | "hasMany", autoload?: boolean}>} - Relationship definitions. */
  static relationshipDefinitions() {
    return {
      user: {type: "belongsTo"},
    }
  }

  /** @returns {Record<string, string>} - Relationship model class names. */
  static relationshipModelClasses() {
    return {
      user: "User",
    }
  }

  /** @returns {CommentAttributes["id"]} - Attribute value. */
  id() { return /** @type {CommentAttributes["id"]} */ (this.readAttribute("id")) }

  /**
   * @param {CommentAttributes["id"] | null} newValue - New attribute value.
   * @returns {CommentAttributes["id"] | null} - Assigned value.
   */
  setId(newValue) { return /** @type {CommentAttributes["id"] | null} */ (this.setAttribute("id", newValue)) }

  /** @returns {CommentAttributes["automationKind"]} - Attribute value. */
  automationKind() { return /** @type {CommentAttributes["automationKind"]} */ (this.readAttribute("automationKind")) }

  /**
   * @param {CommentAttributes["automationKind"] | null} newValue - New attribute value.
   * @returns {CommentAttributes["automationKind"] | null} - Assigned value.
   */
  setAutomationKind(newValue) { return /** @type {CommentAttributes["automationKind"] | null} */ (this.setAttribute("automationKind", newValue)) }

  /** @returns {CommentAttributes["comment"]} - Attribute value. */
  comment() { return /** @type {CommentAttributes["comment"]} */ (this.readAttribute("comment")) }

  /**
   * @param {CommentAttributes["comment"] | null} newValue - New attribute value.
   * @returns {CommentAttributes["comment"] | null} - Assigned value.
   */
  setComment(newValue) { return /** @type {CommentAttributes["comment"] | null} */ (this.setAttribute("comment", newValue)) }

  /** @returns {CommentAttributes["createdAt"]} - Attribute value. */
  createdAt() { return /** @type {CommentAttributes["createdAt"]} */ (this.readAttribute("createdAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setCreatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("createdAt", newValue)) }

  /** @returns {CommentAttributes["resourceId"]} - Attribute value. */
  resourceId() { return /** @type {CommentAttributes["resourceId"]} */ (this.readAttribute("resourceId")) }

  /**
   * @param {CommentAttributes["resourceId"] | null} newValue - New attribute value.
   * @returns {CommentAttributes["resourceId"] | null} - Assigned value.
   */
  setResourceId(newValue) { return /** @type {CommentAttributes["resourceId"] | null} */ (this.setAttribute("resourceId", newValue)) }

  /** @returns {CommentAttributes["resourceType"]} - Attribute value. */
  resourceType() { return /** @type {CommentAttributes["resourceType"]} */ (this.readAttribute("resourceType")) }

  /**
   * @param {CommentAttributes["resourceType"] | null} newValue - New attribute value.
   * @returns {CommentAttributes["resourceType"] | null} - Assigned value.
   */
  setResourceType(newValue) { return /** @type {CommentAttributes["resourceType"] | null} */ (this.setAttribute("resourceType", newValue)) }

  /** @returns {CommentAttributes["updatedAt"]} - Attribute value. */
  updatedAt() { return /** @type {CommentAttributes["updatedAt"]} */ (this.readAttribute("updatedAt")) }

  /**
   * @param {Date | string | null} newValue - New attribute value.
   * @returns {Date | string | null} - Assigned value.
   */
  setUpdatedAt(newValue) { return /** @type {Date | string | null} */ (this.setAttribute("updatedAt", newValue)) }

  /** @returns {CommentAttributes["userId"]} - Attribute value. */
  userId() { return /** @type {CommentAttributes["userId"]} */ (this.readAttribute("userId")) }

  /**
   * @param {CommentAttributes["userId"] | null} newValue - New attribute value.
   * @returns {CommentAttributes["userId"] | null} - Assigned value.
   */
  setUserId(newValue) { return /** @type {CommentAttributes["userId"] | null} */ (this.setAttribute("userId", newValue)) }

  /**
   * Returns user relationship helper.
   * @returns {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Comment, import("./user.js").User, import("./user.js").UserCreateAttributes>} - Relationship helper.
   */
  userRelationship() { return /** @type {import("velocious/build/src/frontend-models/base.js").FrontendModelSingularRelationship<Comment, import("./user.js").User, import("./user.js").UserCreateAttributes>} */ (this.getRelationshipByName("user")) }

  /**
   * Returns user.
   * @returns {import("./user.js").User | null} - Loaded related model.
   */
  user() { return this.userRelationship().loaded() }

  /**
   * Builds user.
   * @param {import("./user.js").UserCreateAttributes} [attributes] - Attributes for the new related model.
   * @returns {import("./user.js").User} - Built related model.
   */
  buildUser(attributes = {}) { return this.userRelationship().build(attributes) }

  /**
   * Loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async loadUser() { return await this.userRelationship().load() }

  /**
   * Returns or loads user.
   * @returns {Promise<import("./user.js").User | null>} - Loaded related model.
   */
  async userOrLoad() { return await this.userRelationship().orLoad() }

  /**
   * Sets user.
   * @param {import("./user.js").User | null} model - Related model.
   * @returns {void}
   */
  setUser(model) { this.userRelationship().setLoaded(model) }

  /**
   * Registers a class-level destroy callback.
   * @overload
   * @param {(payload: {id: string}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * @template {import("velocious/build/src/frontend-models/base.js").FrontendModelClass} T
   * @overload
   * @this {T}
   * @param {(payload: {id: import("velocious/build/src/frontend-models/base.js").FrontendModelEventPrimaryKeyValueFor<InstanceType<T>>}) => void} callback - Event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  /**
   * Implements class-level destroy callback registration.
   * @param {(payload: {id: never}) => void} callback - Type-erased event callback.
   * @param {import("velocious/build/src/frontend-models/base.js").FrontendModelEventOptions} [options] - Destroy event options.
   * @returns {Promise<() => void>} - Unsubscribe callback.
   */
  static async onDestroy(callback, options = {}) {
    return await this._registerDestroyEventCallback(callback, options)
  }
}

FrontendModelBase.registerModel(Comment)

export {Comment}

export default Comment
